import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HeidiLogo from "../assets/HEIDI_Logo_Black.png";
import { register } from "../Services/usersApi";
import Alert from "../Components/Alert";
import { role } from "../Constants/role";
import { sendEmailVerification } from "firebase/auth";

const Register = () => {
	const { t } = useTranslation();
	const [alertInfo, setAlertInfo] = useState(false);
	const [alertMessage, setAlertMessage] = useState("");
	const [alertType, setAlertType] = useState("");
	const [loading, setLoading] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);


	useEffect(() => {
		document.title = process.env.REACT_APP_REGION_NAME;
	}, []);

	const navigate = useNavigate();
	const routeChangeToLogin = () => {
		const path = `/login`;
		navigate(path);
	};

	const navigateTo = (path) => {
		if (path) {
			navigate(path);
		}
	};

	const [isChecked, setIsChecked] = useState(false);

	const [input, setInput] = useState({
		email: "",
		password: "",
		confirmPassword: "",
	});

	const [error, setError] = useState({
		email: "",
		password: "",
		confirmPassword: "",
	});

	const onInputChange = (e) => {
		const { name, value } = e.target;
		setInput((prev) => ({
			...prev,
			[name]: value,
		}));
		validateInput(e);
	};

	input.role = role.User;

	const handleSubmit = async (event) => {
		event.preventDefault();
		setLoading(true);
		setAlertInfo(false);

		try {

			if (!isChecked) {
				setAlertInfo(true);
				setAlertType("danger");
				setAlertMessage("Please agree to the Terms and Conditions to proceed.");
				return;
			}
			if (error.password || error.confirmPassword || error.email) {
				const firstError = Object.values(error).filter(e => e !== "")[0];
				setAlertInfo(true);
				setAlertType("danger");
				setAlertMessage(firstError);
				return;
			}

			const user = await register({
				email: input.email,
				password: input.password,
			});

			await sendEmailVerification(user);

			setAlertInfo(true);
			setAlertType("success");
			setAlertMessage(t("verifyEmail"));

			setTimeout(() => {
				navigate("/login");
			}, 3000);

		} catch (err) {
			console.error("[Register] Registration failed:", err);
			let errorMessage = t("somethingWrong");

			if (err.code === "auth/email-already-in-use" || err.message.includes("EMAIL_EXISTS")) {
				errorMessage = t("emailAlreadyInUse");
			}

			setAlertInfo(true);
			setAlertType("danger");
			setAlertMessage(errorMessage);
		} finally {
			setLoading(false);
		}
	};

	const validateInput = (e) => {
		const { name, value } = e.target;
		setError((prev) => {
			const stateObj = { ...prev, [name]: "" };

			switch (name) {
				case "email":
					if (!value) {
						stateObj[name] = t("pleaseEnterEmailAddress");
					} else if (!/\S+@\S+\.\S+/.test(value)) {
						stateObj[name] = t("invalidEmailAddress");
					}
					break;
				case "password":
					if (!value) {
						stateObj[name] = t("pleaseEnterPassword");
					} else if (!/^\S{8,64}$/.test(value)) {  // Condition to check max 64 characters
						stateObj[name] = t("passwordValidation");
					} else if (input.confirmPassword && value !== input.confirmPassword) {
						stateObj.confirmPassword = t("passwordsDoNotMatch");
					} else {
						stateObj.confirmPassword = input.confirmPassword
							? ""
							: error.confirmPassword;
					}
					break;

				case "confirmPassword":
					if (!value) {
						stateObj[name] = t("pleaseConfirmPassword");
					} else if (input.password && value !== input.password) {
						stateObj[name] = t("passwordsDoNotMatch");
					}
					break;

				default:
					break;
			}

			return stateObj;
		});
	};

	const [isOpen, setIsOpen] = useState(false);

	const openModal = () => {
		setIsOpen(true);
	};

	const closeModal = () => {
		setIsOpen(false);
	};
	const toggleShowPassword = () => {
		setShowPassword(!showPassword);
	};


	const toggleShowConfrimPassword = () => {
		setShowConfirmPassword(!showConfirmPassword);
	};
	return (
		<div className="h-screen w-screen bg-white flex justify-center items-center">
			<div className="grid gap-8">
				<div
					className="rounded-[20px] bg-white shadow-[0_3px_10px_rgb(0,0,0,0.2)] p-10 m-2"
				>
					<div>
						<img
							onClick={() => navigate("/")}
							className="mx-auto h-20 w-auto cursor-pointer"
							src={HeidiLogo}
							alt="HEDI- Heimat Digital"
						/>
						<h3 className="mt-6 text-center text-3xl font-bold tracking-tight text-slate-800">
							{t("createAccount")}
						</h3>
					</div>
					<div className="mt-8 space-y-6">
						<input type="hidden" name="remember" value="true" />
						<div className="space-y-2 rounded-md shadow-sm">
							<input
								id="emailaddress"
								name="email"
								type="email"
								value={input.email}
								onChange={onInputChange}
								onBlur={validateInput}
								autoComplete="email"
								required
								className="border p-3 bg-white text-gray-800 border-gray-700 shadow-md placeholder:text-base duration-300 border-gray-300 rounded-lg w-full"
								placeholder={t("pleaseEnterEmailAddress") + "*"}
							></input>
							<div
								className="mt-2 text-md text-red-500"
								style={{
									visibility: error.email ? "visible" : "hidden",
								}}
							>
								{error.email}
							</div>
							<div className="relative flex items-center">

								<input
									name="password"
									type={showPassword ? "text" : "password"}
									value={input.password}
									onChange={onInputChange}
									onBlur={validateInput}
									required
									className="border p-3 bg-white text-gray-800 border-gray-700 shadow-md placeholder:text-base duration-300 border-gray-300 rounded-lg w-full"
									placeholder={t("pleaseEnterPassword") + '*'}
								/>

								<button
									type="button"
									className="absolute right-0 mr-3 flex font-bold items-center text-sm leading-5 text-gray-500 hover:text-gray-700 focus:outline-none"
									onClick={toggleShowPassword}
									style={{ zIndex: 20 }}
								>
									{showPassword ?
										<svg className="h-6 text-black" fill="none" xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 640 512">
											<path fill="currentColor"
												d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z">
											</path>
										</svg> :
										<svg className="h-6 text-black" fill="none" xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 576 512">
											<path fill="currentColor"
												d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z">
											</path>
										</svg>
									}
								</button>
							</div>
							<div className="relative flex items-center">
								<input
									name="confirmPassword"
									type={showConfirmPassword ? "text" : "password"}
									value={input.confirmPassword}
									onChange={onInputChange}
									onBlur={validateInput}
									required
									className="border p-3 bg-white text-gray-800 border-gray-700 shadow-md placeholder:text-base duration-300 border-gray-300 rounded-lg w-full"
									placeholder={t("pleaseConfirmPassword") + "*"}
								></input>

								<button
									type="button"
									className="absolute right-0 mr-3 flex font-bold items-center text-sm leading-5 text-gray-500 hover:text-gray-700 focus:outline-none"
									onClick={toggleShowConfrimPassword}
									style={{ zIndex: 20 }}
								>
									{showConfirmPassword ?
										<svg className="h-6 text-black" fill="none" xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 640 512">
											<path fill="currentColor"
												d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z">
											</path>
										</svg> :
										<svg className="h-6 text-black" fill="none" xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 576 512">
											<path fill="currentColor"
												d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z">
											</path>
										</svg>
									}
								</button>
							</div>


							<div
								className="mt-2 text-md text-red-500"
								style={{
									visibility: error.confirmPassword ? "visible" : "hidden",
								}}
							>
								{error.confirmPassword}
							</div>
						</div>

						<div className="flex items-center justify-between">
							<div className="flex items-center">
								<input
									name="remember-me"
									type="checkbox"
									onChange={() => setIsChecked(!isChecked)}
									className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
									required
								/>
								<label
									htmlFor="remember-me"
									className="ml-2 block text-sm text-slate-800"
								>
									{t("i_hereby_accept_the")}
									<a
										onClick={() => {
											navigateTo("/PrivacyPolicy");
										}}
										target="_blank"
										rel="noopener noreferrer"
										className="text-red-500 hover:text-red-300"
									>
										{t("privacy_policy")}
									</a>
									{t("and_the")}
									<a
										onClick={() => {
											navigateTo("/ImprintPage");
										}}
										className="text-red-500 hover:text-red-300"
									>
										{t("terms_conditions")}
									</a>
								</label>
							</div>
						</div>

						{loading ? (
							<button type="button" className="bg-gradient-to-r font-md text-gray-300 from-gray-700 to-slate-600 shadow-lg p-2 text-white rounded-lg w-full hover:scale-105 hover:from-gray-700 hover:to-slate-600 transition duration-300 ease-in-out">
								<span className="absolute inset-y-0 left-0 flex items-center pl-3">
									<svg aria-hidden="true" className="w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-white" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
										<path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
									</svg>
								</span>
								{t("processing")}
							</button>
						) : (
							<div>
								<button
									type="submit"
									id="finalbutton"
									onClick={handleSubmit}
									className="bg-gradient-to-r font-md text-gray-300 from-gray-700 to-slate-600 shadow-lg p-2 text-white rounded-lg w-full hover:scale-105 hover:from-gray-700 hover:to-slate-600 transition duration-300 ease-in-out"
								>
									{t("register")}
								</button>
							</div>
						)}

						{alertInfo && (
							<div className="py-2 mt-1 px-2">
								<Alert type={alertType} message={alertMessage} />
							</div>
						)}

						<div className="flex justify-between">
							<div className="text-sm">
								{t("accountPresent")}
								<span
									onClick={routeChangeToLogin}
									className="font-medium cursor-pointer text-slate-800 hover:text-slate-600"
								>
									{t("loginHere")}
								</span>
							</div>

							<div className="flex cursor-pointer">
								<span
									onClick={openModal}
									className="font-medium cursor-pointer text-slate-800 hover:text-slate-600"
								>
									{t("Help")}
								</span>

								{isOpen && (
									<div className="fixed inset-0 flex items-center justify-center z-50">
										<div className="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"></div>

										<div className="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded-lg shadow-lg z-50 overflow-y-auto">
											<div className="modal-content py-4 text-left px-6">
												<div>
													<h2 className="font-bold text-blue-600 text-xl text-center mb-6">
														{t("anleitung")}
													</h2>
													<h3 className="font-bold text-blue-600 text-lg text-center mb-6">
														{t("subtitle")}
													</h3>
													<p className="mb-6 text-gray-800" dangerouslySetInnerHTML={{ __html: t("step1") }}></p>
													<p className="mb-6 text-gray-800" dangerouslySetInnerHTML={{ __html: t("step2") }}></p>
													<p className="mb-6 text-gray-800" dangerouslySetInnerHTML={{ __html: t("step3") }}></p>
													<p className="mb-6 text-gray-800" dangerouslySetInnerHTML={{ __html: t("step4") }}></p>
													<p className="font-bold text-blue-600 text-lg text-center mb-6">
														<strong>{t("thankYou")}</strong>
													</p>
												</div>

												<div className="mt-6 text-center">
													<button
														onClick={closeModal}
														className="bg-gradient-to-r font-md text-gray-300 from-gray-700 to-slate-600 shadow-lg p-2 text-white rounded-lg w-full hover:scale-105 hover:from-gray-700 hover:to-slate-600 transition duration-300 ease-in-out"
													>
														{t("cancel")}
													</button>
												</div>
											</div>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default Register;
